module.exports = __webpack_public_path__ + "img/huaban-6666154900@2x.edceac7c.png";